module.exports = __webpack_public_path__ + "static/create-share-links-mobile-b701e3a7c6dd2303bb113e13738ab066.png";